export class GlobalErrorHandlerHelper {
  constructor() {}

  static whitelistErrorRegexes: string[] = ['^Error retrieving icon [^!]*! Http failure response for '];

  public static isErrorWhitelisted(errorMessage: string): boolean {
    let isWhitelisted = false;

    this.whitelistErrorRegexes.some(regex => {
      isWhitelisted = RegExp(regex).test(errorMessage);
      return isWhitelisted;
    });

    return isWhitelisted;
  }
}
